import { observer } from "mobx-react";
import { FormField } from "../../../../../../components/form-field/form-field";
import { RETURNS_PORTAL_TRANSLATION_KEYS } from "../../constants";
import useTranslation from "../../../../../../translation/hooks/translation-hook";
import { useImperativeHandle } from "react";
import TranslationRichTextEditor from "../../../../../../translation/translation-rich-text-editor/translation-rich-text-editor";

export interface ILocateOrderLocateOrderEntryRef {
    save: () => Promise<void>;
    discardChanges: () => void;
    hasChanges: () => boolean;
}

interface ILocateOrderLocateOrderEntryProps {
    ref: React.RefObject<ILocateOrderLocateOrderEntryRef>;
}

const LocateOrderLocateOrderEntry: React.FC<ILocateOrderLocateOrderEntryProps> = observer(({ ref }) => {
    const { hasChanges, discardChanges, save } = useTranslation();

    useImperativeHandle(ref, () => ({
        save: () => {
            if (hasChanges()) {
                return save();
            }

            return Promise.resolve();
        },
        discardChanges: () => {
            if (hasChanges()) {
                discardChanges();
            }
        },
        hasChanges: () => {
            return hasChanges();
        },
    }));

    return (
        <FormField label="Instructions">
            <TranslationRichTextEditor minHeight={250} translationKey={RETURNS_PORTAL_TRANSLATION_KEYS.FIRST_PAGE_CONTENT} />
        </FormField>
    );
});

export default LocateOrderLocateOrderEntry;